
import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import SharedTools from '../../lib/SharedTools';

export default class RegisterationReportPage extends React.Component {

  static propTypes = {
      // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
     // set state
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      year: new Date().getFullYear(),
      month: new Date().getMonth()+1,
      school_id: props.params.schoolId,
      grade_number: null,
      unregistered_teachers: [],
      unregistered_students: [],
      registeration_teachers: [
        {name: '应注册老师', count: 0},
        {name: '已注册老师', count: 0},
        {name: '未注册老师', count: 0},
      ],
      registeration_students: [
        {name: '应绑定学生', count: 0},
        {name: '已绑定学生', count: 0},
        {name: '未绑定学生', count: 0},
      ],
      scope: ''
    }
  }

  componentDidMount() {
    let grade_number = (this.state.currentRole.associatName === 'school' || this.state.currentRole.associatName === 'system') ? null : this.state.currentRole.associatName === 'classGrade' ? this.state.currentRole.associatObj.grade_number : null;
    let data = {
      school_id: this.state.school_id,
      year: this.state.year,
      grade_number: grade_number,
      month: this.state.month
    };
    let that = this;
    DataService.getRegisterationData(data).then(res => {
      that.setState({
        grade_number: grade_number,
        unregistered_teachers: res.unregistered_teachers,
        unregistered_students: res.unregistered_students,
        registeration_teachers: [
          {name: '应注册老师', count: res.total_teachers_count},
          {name: '已注册老师', count: res.total_teachers_count - res.unregistered_teachers_count},
          {name: '未注册老师', count: res.unregistered_teachers_count},
        ],
        registeration_students: [
          {name: '应绑定学生', count: res.total_students_count},
          {name: '已绑定学生', count: res.total_students_count - res.unregistered_students_count},
          {name: '未绑定学生', count: res.unregistered_students_count},
        ],
        scope: res.scope
      })
    }).then((err) => {
      if(err) {
        console.log(err);
      }
    });
  }
  
  render() {
    return (
      <div className="school-registeration-report-page">
        <div className="registeration-container">
          <div className="clearfix">
            <div className="label label-left">统计时间</div>
            <div className="label label-right">{this.state.year}年{this.state.month}月</div>
          </div>
          <div className="clearfix">
            <div className="label label-left">统计年段</div>
            <div className="label label-right">{this.state.scope}</div>
          </div>
        </div>

        <div className="registeration-container">
          {this.state.registeration_teachers.map((item, index) => <div key={index} className="clearfix">
            <div className="label label-left">{item.name}</div>
            <div className="label label-right"><span className="count">{item.count}</span>人</div>
          </div>)}

          <div className="unregistered-students-list">
            {this.state.unregistered_teachers.map((student) => <div className="student-item" key={student.id}>{student.full_name}</div>)}
          </div>
        </div>

        <div className="registeration-container">
          {this.state.registeration_students.map((item, index) => <div key={index} className="clearfix">
            <div className="label label-left">{item.name}</div>
            <div className="label label-right"><span className="count">{item.count}</span>人</div>
          </div>)}

          <div className="unregistered-students-list">
            {this.state.unregistered_students.map((item, index) => <div className="unregistered-classes-container" key={index}>
              <div className="class-item clearfix" >
                <div className="label label-left"><span className="class-name">{item.name}</span></div>
                <div className="label label-right"><span className="count">{item.students.length}</span>人</div>
              </div>
              {item.students.map((student) => <div className="student-item" key={student.id}>{student.full_name}
              </div>)}
            </div>)}
          </div>
        </div>

      </div>
    )
  }
}








// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/schooladmin/RegisterationReportPage.jsx